module.exports = __webpack_public_path__ + "static/img/logo02.824922a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo02.png
// module id = 34xT
// module chunks = 0